import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';

import { reducer } from './reducer';
import { StudioHomeStoreEffects } from './effects';

@NgModule({
    imports: [
        CommonModule,

        StoreModule.forFeature('studio-home', reducer),
        EffectsModule.forFeature([StudioHomeStoreEffects]),
    ],
    providers: [],
})
export class StudioHomeStoreModule { }
